import gev from '../images/GEV.png';
import nselogo from '../images/NSE-logo.png'
import iitk_logo from '../images/iitk_logo.png';
import igbc from '../images/IGBC.jpg'

import goi from '../images/Government_of_India_logo.png'
import cii from "../images/cii-logo.png"
import crdc from "../images/creduce-logo.png"
import ficci from "../images/FICCI_logo.png"
import hsa from "../images/hsa.png"
import terviva from "../images/terviva-logo.png"
import gom from "../images/Seal_of_Maharashtra.svg.webp"
import nitw from "../images/NITW-logo.png"
import moefcc from "../images/moefcc-logo.jpg"
import iitb from "../images/gush-iitb.jpeg"
import iiti from "../images/IIT_Indore_Logo.png"
import assocham from "../images/assocham-logo.jpg"
import ksos from "../images/Kotak-School.jpeg"
import nw from "../images/national-warangal.jpeg"

const SupportersLogo = {
  Organiser: [
    { title: 'GEV', img: gev, webpage: 'https://ecovillage.org.in/' }
  ],
  Venue: [
    { title: 'NSE', img: nselogo, webpage: 'https://www.nseindia.com' }
  ],
  Associate: [
    { title: 'KSOS', img: ksos, webpage: 'https://iitk.ac.in' },
    { title: 'IGBC', img: igbc, webpage: 'https://igbc.in/' },
    { title: 'IITB', img: iitb, webpage: 'https://gesh.iitb.ac.in/' },
    { title: 'National Warangal', img: nw, webpage: 'https://www.nitw.ac.in/' },
  ],

  Supporters_1: [

    { title: 'IIT Bombay', img: iitb, webpage: 'https://www.iitb.ac.in/' },
    { title: 'IIT Indore', img: iiti, webpage: 'https://www.iiti.ac.in/' },
    { title: 'NIT Warangal', img: nitw, webpage: 'https://www.nitw.ac.in/' },
    { title: 'CII', img: cii, webpage: 'https://www.cii.in/' },
    { title: 'FICCI', img: ficci, webpage: 'https://www.ficci.in/' },
    { title: 'ASSOCHAM', img: assocham, webpage: 'https://www.assocham.org/' },

  ],
  Supporters_2: [
    { title: 'Terviva', img: terviva, webpage: 'https://terviva.com/' },
    { title: 'Creduce', img: crdc, webpage: 'https://creduce.tech/' },
    { title: 'HSA', img: hsa, webpage: 'http://hitensethi.com/' }
  ]

};


export default SupportersLogo;